var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldEditorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold_24px",
    transform: "translate(-670 -352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    transform: "translate(1 -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(669 366)",
    fill: "#e6e6e8",
    opacity: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "B",
    transform: "translate(675 385)",
    fill: "#0d0d0d",
    fontSize: 16,
    fontFamily: "Verdana-Bold, Verdana",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldEditorIcon);
export default __webpack_public_path__ + "static/media/bold-editor-icon.2cd3e66b68c0d9bd31c816b93d83b437.svg";
export { ForwardRef as ReactComponent };